import React, { Dispatch, SetStateAction } from 'react';

import Alert from '@amzn/meridian/alert';
import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Loader from '@amzn/meridian/loader';
import Modal, { ModalFooter } from '@amzn/meridian/modal';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import Textarea from '@amzn/meridian/textarea';

interface IConfirmationModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    body?: string;
    children?: JSX.Element;
    comments?: string;
    showComments?: boolean;
    warning?: string;
    showWarning?: boolean;
    onCommentsChange?: Dispatch<SetStateAction<string>>;
    primaryButtonText: string;
    primaryButtonOnClick: () => void;
    secondaryButtonText: string;
    secondaryButtonOnClick: () => void;
    isLoading?: boolean;
}

export const LoaderForBtn = (
    <Row width={60} alignmentHorizontal="center">
        <Loader size="small" />
    </Row>
);

export const ConfirmationModal = ({
    isOpen,
    onClose,
    title,
    body,
    children,
    comments = '',
    showComments = false,
    warning = '',
    showWarning = false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onCommentsChange = () => {},
    primaryButtonText,
    primaryButtonOnClick,
    secondaryButtonText,
    secondaryButtonOnClick,
    isLoading = false
}: IConfirmationModalProps) => {
    return (
        <Modal
            title={title}
            open={isOpen}
            onClose={onClose}
            scrollContainer="viewport"
            closeLabel="Close"
            aria-describedby="modal-description"
        >
            <Column>
                {body && <Text>{body}</Text>}
                {children}
                {showWarning && <Alert type="warning">{warning}</Alert>}
                {showComments && (
                    <Textarea
                        placeholder="Comments *"
                        value={comments}
                        onChange={onCommentsChange}
                        resize="none"
                        width="100%"
                    />
                )}
            </Column>
            <ModalFooter>
                <Row alignmentHorizontal="end" widths="fit">
                    <Button type="secondary" size="small" onClick={secondaryButtonOnClick}>
                        {secondaryButtonText}
                    </Button>
                    <Button
                        type="primary"
                        size="small"
                        disabled={(showComments && !comments) || isLoading}
                        onClick={primaryButtonOnClick}
                    >
                        {isLoading ? LoaderForBtn : primaryButtonText}
                    </Button>
                </Row>
            </ModalFooter>
        </Modal>
    );
};
